import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login/index'
import login2 from '@/views/login2/index'
import loginm1 from '@/views/loginm1/index'
import loginm2 from '@/views/loginm2/index'
import layout from '../views/layout.vue'
import user_list from '../views/user/list.vue'
import calculationdialog_list from '../views/calculation_dialog/list.vue'
import shopdiaglog_list from '../views/shopdiaglog/list.vue'
import qa_list from '../views/qa/list.vue'
import money_list from '../views/money/list.vue'
import game_list from '../views/game/list.vue'
import gamers_list from '../views/gamers/list.vue'
import gamesd_list from '../views/gamesd/list.vue'
import gamesp_list from '../views/gamesp/list.vue'
import gamegd_list from '../views/gamegd/list.vue'
import gamehn_list from '../views/gamehn/list.vue'
import gamess_list from '../views/gamess/list.vue'
import gamespnew_list from '../views/gamespnew/list.vue'
import moneyout_list from '../views/moneyout/list.vue'
import rolling_c_list from '../views/rolling_c/list.vue'
import configlist_list from '../views/configlist/list.vue'
import jang_list from '../views/jang/list.vue'
import jangnew_list from '../views/jangnew/list.vue'
import sitestat_list from '../views/sitestat/list.vue'
import moneystat_list from '../views/moneystat/list.vue'
import rollingstat_list from '../views/rollingstat/list.vue'
import order_list from '../views/order/list.vue'
import orderoffer_list from '../views/orderoffer/list.vue'
import memo_list from '../views/memo/list.vue'
import coupon_list from '../views/coupon/list.vue'
import delac_list from '../views/delac/list.vue'
import memo_list_user from '../views/memo_user/list.vue'
import memo_list_pt from '../views/memo_pt/list.vue'

import rdp_list from '../views/rdp/list.vue'
import urdp_list from '../views/urdp/list.vue'
import moneylogs_list from '../views/moneylogs/list.vue'

import moneylogs_list_user from '../views/moneylogs_user/list.vue'
import moneylogs_list_pt from '../views/moneylogs_pt/list.vue'
import gamediaglog_list from '../views/gamediaglog/list.vue'

import acclist_list from '../views/acclist/list.vue'
import online_list from '../views/online/list.vue'

import board_list from '../views/board/list.vue'
import pop_list from '../views/pop/list.vue'
import powerball_list from '../views/powerball/list.vue'
import powerball_bg_list from '../views/powerball_bg/list.vue'
import sadari_bg_list from '../views/sadari_bg/list.vue'
import sadari_list from '../views/sadari/list.vue'
import bubon_list from '../views/bubon/list.vue'

import bon_list from '../views/bon/list.vue'
import master_list from '../views/master/list.vue'


import zp_list from '../views/zp/list.vue'
import settings_list from '../views/settings/list.vue'
import settings_edit_list from '../views/settings_edit/list.vue'
import log_list from '../views/log/list.vue'
import autoqa_list from '../views/autoqa/list.vue'
import moneybak_list from '../views/moneybak/list.vue'
import refresh from '../components/common/refresh.vue'
import redirect from '../components/redirect.vue'

import alert_list from '../views/alert/list.vue'
import calculation_list from '../views/calculation/list.vue'
import calculation_new_list from '../views/calculation_new/list.vue'
import act_list from '../views/act/list.vue'
import buy_list from '../views/buy/list.vue'
import admin_list from '../views/admin/list.vue'
import race_list from '../views/race/list.vue'
import racelist_list from '../views/racelist/list.vue'
import inout_list from '../views/inout/list.vue'
import inoutzp_list from '../views/inoutzp/list.vue'
import dcheck_list from '../views/dcheck/list.vue'
import lossrace_list from '../views/lossrace/list.vue'
import memlist_list from '../views/memlist/list.vue'
import moneyadd_list from '../views/moneyadd/list.vue'
import sp_list from '../views/shop/list.vue'
import betting_list from '../views/betting/list.vue'
import betting_list1 from '../views/betting1/list.vue'
import betting_list2 from '../views/betting2/list.vue'
import betting_list3 from '../views/betting3/list.vue'
import betting_list4 from '../views/betting4/list.vue'
import betting_list5 from '../views/betting5/list.vue'
import betting_list6 from '../views/betting6/list.vue'
import betting_list7 from '../views/betting7/list.vue'
import dashboard_index from '../views/dashboard/index'
import orderapi_list from '../views/orderapi/list.vue'
import ordergro_list from '../views/ordergro/list.vue'
import losinglist_list from '../views/losinglist/list.vue'
import losinglist_bon from '../views/losinglist_bon/list.vue'


Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push=function push(to){
return VueRouterPush.call(this,to).catch(err=> err)
}

export default new Router({
  routes: [

  {
      path: '/refresh',
      name: 'refresh',
      component: refresh
    },
    {
     path: '/redirect',
     name: 'redirect',
     component: redirect
    },
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/',
      name: 'login2',
      component: login2
    },
    {
      path: '/gamediaglog/list',
      name: 'gamediaglog_list',
      component: gamediaglog_list
    },
     {
            path:'/shopdiaglog/list',
            name:'shopdiaglog_list',
            component:shopdiaglog_list
          },
           {
            path:'/calculation_dialog/list',
            name:'calculationdialog_list',
            component:calculationdialog_list
          },
     {
      path: '/',
      name: 'loginm1',
      component: loginm1
    },
     {
      path: '/',
      name: 'loginm2',
      component: loginm2
    },
    {
      path: '/index',
      name: 'layout',
      component: layout,
      redirect:'/user/list',
         children:[
          {
            path:'/dashboard/index',
            name:'dashboard_index',
            component:dashboard_index
          },
         
          
          {
            path:'/qa/list',
            name:'qa_list',
            component:qa_list
          },
          {
            path:'/game/list',
            name:'game_list',
            component:game_list
          },
          {
            path:'/gamesd/list',
            name:'gamesd_list',
            component:gamesd_list
          },
           {
            path:'/gamers/list',
            name:'gamers_list',
            component:gamers_list
          },
           {
            path:'/gamesp/list',
            name:'gamesp_list',
            component:gamesp_list
          }, {
            path:'/gamespnew/list',
            name:'gamespnew_list',
            component:gamespnew_list
          },
           {
            path:'/gamehn/list',
            name:'gamehn_list',
            component:gamehn_list
          },
          {
            path:'/gamess/list',
            name:'gamess_list',
            component:gamess_list
          },
            {
            path:'/gamegd/list',
            name:'gamegd_list',
            component:gamegd_list
          },
          {
            path:'/user/list',
            name:'user_list',
            component:user_list,
           

          },
          {
            path:'/rdp/list',
            name:'rdp_list',
            component:rdp_list,
           

          },
           {
            path:'/jang/list',
            name:'jang_list',
            component:jang_list,
           

          },
          {
            path:'/jangnew/list',
            name:'jangnew_list',
            component:jangnew_list,
           

          },
          {
            path:'/calculation_new/list',
            name:'calculation_new_list',
            component:calculation_new_list,
           

          },
          {
            path:'/urdp/list',
            name:'urdp_list',
            component:urdp_list,
           

          },
          {
            path:'/configlist/list',
            name:'configlist_list',
            component:configlist_list,
           

          },
           {
            path:'/moneystat/list',
            name:'moneystat_list',
            component:moneystat_list,
           

          },
          {
            path:'/rollingstat/list',
            name:'rollingstat_list',
            component:rollingstat_list,
           

          },
           {
            path:'/memlist/list',
            name:'memlist_list',
            component:memlist_list,
           

          },
           {
            path:'/money/list',
            name:'money_list',
            component:money_list
          },
           
           {
            path:'/coupon/list',
            name:'coupon_list',
            component:coupon_list
          },
           {
            path:'/delac/list',
            name:'delac_list',
            component:delac_list
          },
          {
            path:'/rolling_c/list',
            name:'rolling_c_list',
            component:rolling_c_list
          },
            {
            path:'/sitestat/list',
            name:'sitestat_list',
            component:sitestat_list
          },
          {
            path:'/ordergro/list',
            name:'ordergro_list',
            component:ordergro_list
          },
          {
            path:'/orderoffer/list',
            name:'orderoffer_list',
            component:orderoffer_list
          },
          {
            path:'/moneyadd/list',
            name:'moneyadd_list',
            component:moneyadd_list
          },
            {
            path:'/moneyout/list',
            name:'moneyout_list',
            component:moneyout_list
          },
          
           {
            path:'/order/list',
            name:'order_list',
            component:order_list
          },
           {
            path:'/orderapi/list',
            name:'orderapi_list',
            component:orderapi_list
          },
          {
            path:'/memo/list',
            name:'memo_list',
            component:memo_list
          },
          {
            path:'/memo_user/list',
            name:'memo_list_user',
            component:memo_list_user
          },
          {
            path:'/memo_pt/list',
            name:'memo_list_pt',
            component:memo_list_pt
          },
           {
            path:'/moneylogs/list',
            name:'moneylogs_list',
            component:moneylogs_list
          },
          {
            path:'/moneylogs_user/list',
            name:'moneylogs_list_user',
            component:moneylogs_list_user
          },
          {
            path:'/moneylogs_pt/list',
            name:'moneylogs_list_pt',
            component:moneylogs_list_pt
          },
          {
            path:'/acclist/list',
            name:'acclist_list',
            component:acclist_list
          },
           {
            path:'/online/list',
            name:'online_list',
            component:online_list
          },
           {
            path:'/board/list',
            name:'board_list',
            component:board_list
          },
            {
            path:'/pop/list',
            name:'pop_list',
            component:pop_list
          },
          {
            path:'/powerball/list',
            name:'powerball_list',
            component:powerball_list
          },
          {
            path:'/powerball_bg/list',
            name:'powerball_bg_list',
            component:powerball_bg_list
          },
          {
            path:'/bubon/list',
            name:'bubon_list',
            component:bubon_list
          },
          {
            path:'/bon/list',
            name:'bon_list',
            component:bon_list
          },
          {
            path:'/master/list',
            name:'master_list',
            component:master_list
          },
            {
            path:'/sadari/list',
            name:'sadari_list',
            component:sadari_list
          },
          {
            path:'/sadari_bg/list',
            name:'sadari_bg_list',
            component:sadari_bg_list
          },
          {
            path:'/zp/list',
            name:'zp_list',
            component:zp_list
          },
           {
            path:'/admin/list',
            name:'admin_list',
            component:admin_list
          },
          {
            path:'/settings/list',
            name:'settings_list',
            component:settings_list
          },
          {
            path:'/settings_edit/list',
            name:'settings_edit_list',
            component:settings_edit_list
          },
           {
            path:'/log/list',
            name:'log_list',
            component:log_list
          },
           {
            path:'/autoqa/list',
            name:'autoqa_list',
            component:autoqa_list
          },
           {
            path:'/moneybak/list',
            name:'moneybak_list',
            component:moneybak_list
          },
           {
            path:'/calculation/list',
            name:'calculation_list',
            component:calculation_list
          },
           {
            path:'/alert/list',
            name:'alert_list',
            component:alert_list
          },
          {
            path:'/act/list',
            name:'act_list',
            component:act_list
          },
           {
            path:'/buy/list',
            name:'buy_list',
            component:buy_list
          },
          
           {
            path:'/race/list',
            name:'race_list',
            component:race_list
          },
          {
            path:'/racelist/list',
            name:'racelist_list',
            component:racelist_list
          },
           {
            path:'/inout/list',
            name:'inout_list',
            component:inout_list
          },
           {
            path:'/inoutzp/list',
            name:'inoutzp_list',
            component:inoutzp_list
          },
          {
            path:'/dcheck/list',
            name:'dcheck_list',
            component:dcheck_list
          },
           {
            path:'/lossrace/list',
            name:'lossrace_list',
            component:lossrace_list
          },
           {
            path:'/shop/list',
            name:'sp_list',
            component:sp_list
          },
          {
            path:'/betting/list',
            name:'betting_list',
            component:betting_list
          },
          {
            path:'/betting1/list',
            name:'betting_list1',
            component:betting_list1
          },
          {
            path:'/betting2/list',
            name:'betting_list2',
            component:betting_list2
          },
          {
            path:'/betting3/list',
            name:'betting_list3',
            component:betting_list3
          },
          {
            path:'/betting4/list',
            name:'betting_list4',
            component:betting_list4
          },
          {
            path:'/betting5/list',
            name:'betting_list5',
            component:betting_list5
          },
          {
            path:'/betting6/list',
            name:'betting_list6',
            component:betting_list6
          },
          {
            path:'/betting7/list',
            name:'betting_list7',
            component:betting_list7
          },
           {
            path:'/losinglist/list',
            name:'losinglist_list',
            component:losinglist_list
          },
          {
            path:'/losinglist_bon/list',
            name:'losinglist_bon',
            component:losinglist_bon
          },
      ]

    }
  ],
  mode:"history" 
})



// WEBPACK FOOTER //
// ./src/router/index.js